import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Button, IconButton, Menu, MenuItem } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import { MoreVert } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { format } from "date-fns";
import "./ViewProjectTable.css";
import { styled } from "@mui/material/styles";
import Fade from "@mui/material/Fade";
import AssignUserModal from "../../../components/uikit/components/modals/AssgnUserModal/AssignUserModal";
import Note from "../../../assets/images/notes.svg";
import Pagination from "../../../components/uikit/components/Pagination/Pagination";
import deleteicon from "../../../assets/images/blackdelete.svg";
import bluedelete from "../../../assets/images/bluedelete.svg";
import LockSwitch from "../../../components/uikit/components/LockSwitch/LockSwitch";
import Tooltip from "../../../components/uikit/components/Tooltip/Tooltip";
import AccessDeniedModal from "../../../components/uikit/components/modals/AccessDeniedModal/AccessDeniedModal";
import { routespath } from "../../../constants";
import {
  setCurrentProjectDetail,
  setStepcompleted,
  toggleProjectLock,
  setCurrentMVOCDetail,
} from "../../../features/product/projectSlice";
import { clarityNav } from "../../../services/api/clarityNav/apiService";
import { PROJECT_TYPE, SNACKBAR_TYPES } from "../../../constants/constant";
import {
  closeSnackbar,
  openSnackbar,
} from "../../../features/snackbar/snackbarslice";
import fileuserplus from "../../../assets/images/FiUserPlus.svg";
import fileuserminus from "../../../assets/images/user-plus.svg";
import { setUserID } from "../../../features/currentUser/currentUserSlice";
import Binimage from "../../../assets/images/bin.svg";
import delete_icon from "../../../assets/images/FaRegTrashCan.svg";

function customCheckbox(theme) {
  return {
    "& .MuiCheckbox-root": {
      height: 34,
      minHeight: 34,
    },
    "& .MuiCheckbox-root svg": {
      width: 16,
      height: 16,
      backgroundColor: "transparent",
      border: "none",
      borderRadius: 3,
      boxShadow: "0px 0px 2px rgba(0,0,0,0.3)",
    },
    "& .MuiCheckbox-root svg path": {
      display: "none",
    },
    "& .MuiCheckbox-root.Mui-checked:not(.MuiCheckbox-indeterminate) svg": {
      backgroundColor: "#5E5ADB",
      borderColor: "#5E5ADB",
    },
    "& .MuiCheckbox-root.Mui-checked .MuiIconButton-label:after": {
      position: "absolute",
      display: "table",
      border: "2px solid #fff",
      borderTop: 0,
      borderLeft: 0,
      transform: "rotate(45deg) translate(-50%,-50%)",
      opacity: 1,
      transition: "all .2s cubic-bezier(.12,.4,.29,1.46) .1s",
      content: '""',
      top: "50%",
      left: "39%",
      width: 5.71428571,
      height: 9.14285714,
    },
    "& .MuiCheckbox-root.MuiCheckbox-indeterminate .MuiIconButton-label:after":
      {
        width: 8,
        height: 8,
        backgroundColor: "#1890ff",
        transform: "none",
        top: "39%",
        border: 0,
      },
  };
}
const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  border: 0,
  color: "#25282B",
  fontFamily: "Montserrat",
  WebkitFontSmoothing: "auto",
  letterSpacing: "0.2px",
  "& .MuiDataGrid-columnsContainer": {
    backgroundColor: "#ffffff",
  },
  "& .MuiDataGrid-iconSeparator": {
    display: "none",
  },
  "& .MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
    borderRight: 0,
  },
  "& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell": {
    borderBottom: "1px solid #E9EDF5",
  },
  "& .MuiDataGrid-cell": {
    color: "#25282B",
  },
  "& .MuiPaginationItem-root": {
    borderRadius: 0,
  },
  ...customCheckbox(theme),
}));
const ViewProjectTable = ({
  data,
  selectedRow,
  setSelectedRow,
  activeTab,
  anchorEl,
  setAnchorEl,
  setMultipleDeleteModal,
  setMultipleArchivedModal,
  items,
  handlePagination,
  pageValue,
  setPageValue,
  selectedPage,
  setSelectedPage,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // State to control Assign user modal
  const [openAssignUserModal, setOpenAssignUserModal] = useState(false);
  const [currentProjectId, setCurrentProjectId] = useState();
  const [currentProjectOwner, setCurrentProjectOwner] = useState();
  const [currentCollaborator, setCurrentCollaborator] = useState([]);
  const [activepage] = useState({ projects: 1, archived: 1 });
  const [openAccessDeniedModal, setOpenAccessDeniedModal] = useState(false);
  const [accessDeniedUserEmail, setAccessDeniedUserEmail] = useState("");
  const userInfo = useSelector((state) => state?.product?.users ?? "");
  const currentuser = useSelector((state) => state.currentUserDetail);
  const currentusername = useSelector(
    (state) => state?.currentUserDetail?.userLoginName
  );
  const [lockProject] = clarityNav.useLockProjectMutation();
  const [unlockProject] = clarityNav.useUnlockProjectMutation();
  const [fetchProjectDataById] =
    clarityNav.endpoints.getProjectDataFromProjectId.useLazyQuery();

  function getUserIdByEmail(userLoginEmail) {
    if (!Array.isArray(userInfo) || !userLoginEmail) {
      return null;
    }

    const user = userInfo.find((user) => user.email === userLoginEmail);

    return user ? user.user_id : null;
  }

  const currentUserId = getUserIdByEmail(currentuser?.userLoginEmail);
  function getEmailByUserId(lockUserId,userInfo) {
    if (!Array.isArray(userInfo) || !lockUserId) {
      return null;
    }

    const user = userInfo.find((user) => user.user_id === lockUserId);
    return user ? user.email : null;
  }

  const handleLinkClick = async (projectId, row, event) => {
    event.preventDefault();
    // const { lockUserEmail, lockUserId } = getLockUserInfo(
    //   row?.collaborators,
    //   row?.project_lock_user_id,
    //   row.created_by,
    //   userInfo
    // );
    const lockUserId = row?.project_lock_user_id;
    const lockUserEmail = getEmailByUserId(lockUserId);
    const isLocked = lockUserId !== null && lockUserId !== undefined;
    if (
      row?.collaborators?.length &&
      isLocked &&
      lockUserId !== currentUserId
    ) {
      setAccessDeniedUserEmail(lockUserEmail ?? "");
      setOpenAccessDeniedModal(true);
    } else {
      // updateLastViewedProject(projectId);
      const { data } = await fetchProjectDataById(row?.id);
      // get mvoc data by project id
      if (data?.success) {
        dispatch(setCurrentProjectDetail(data.result));
      }
      dispatch(setCurrentProjectDetail(row));
      dispatch(setStepcompleted(2));
      navigate(`${routespath[0].createProjectDetails}/${projectId}`);
    }
  };

  const renderSwitch = (collaborators, projectId, row) => {
    async function handleSwitchToggleRequest(e) {
      const lockUserId = row.project_lock_user_id;
      const lockUserEmail = getEmailByUserId(lockUserId);
      const isLocked = lockUserId !== null && lockUserId !== undefined;

      if (isLocked) {
        if (row.project_lock_user_id !== currentUserId) {
          setAccessDeniedUserEmail(lockUserEmail ?? "");
          setOpenAccessDeniedModal(true);
        } else {
          try {
            const response = await unlockProject({ projectId }).unwrap();
            // await handlePagination(selectedPage);
            if (response?.success) {
              dispatch(toggleProjectLock({ projectId, response, activeTab }));
            }
          } catch (error) {
            dispatch(
              openSnackbar({
                message: error.message,
                type: SNACKBAR_TYPES.ERROR,
              })
            );
            setTimeout(() => {
              dispatch(closeSnackbar());
            }, 10000);
          }
        }
      } else {
        try {
          const response = await lockProject({ projectId }).unwrap();
          // await handlePagination(selectedPage);
          if (response?.success) {
            dispatch(toggleProjectLock({ projectId, response, activeTab }));
          }
        } catch (error) {
          dispatch(
            openSnackbar({ message: error.message, type: SNACKBAR_TYPES.ERROR })
          );
          setTimeout(() => {
            dispatch(closeSnackbar());
          }, 10000);
        }
      }
    }
    if (collaborators?.length > 0) {
      const lockUserId = row.project_lock_user_id;
      const lockUserEmail = getEmailByUserId(userInfo, lockUserId);
      const isLocked = lockUserId !== null && lockUserId !== undefined;
      return (
        <LockSwitch
          isChecked={isLocked}
          onClick={handleSwitchToggleRequest}
          toolTipTitle={lockUserEmail}
        />
      );
    } else {
      return <></>;
    }
  };

  // Adding Collaborators in table
  const renderCollaborators = (collaborators) => {
    const tooltipTitle = collaborators
      ?.map((collaborator) => collaborator.name)
      .join(", ");
    return (
      <Tooltip title={tooltipTitle} placement="left-end">
        <AvatarGroup max={4} className="avatar-group ">
          {collaborators?.map((collaborator, index) => {
            const AvatarName = collaborator?.name || collaborator?.email;
            return (
              <Avatar key={index} className="avatar-list">
                {AvatarName?.[0]?.toUpperCase()}
              </Avatar>
            );
          })}
        </AvatarGroup>
      </Tooltip>
    );
  };

  // handle action menu click
  const handleMenuClick = (event, record) => {
    if (anchorEl !== event.currentTarget) {
      setSelectedRow([record.id]);
      setAnchorEl(event.currentTarget);
    }
  };

  // Function used to add/Assign user to the project
  const handleAssignUser = (e, record) => {
    e.preventDefault();
    const collaborator = record.row?.collaborators.map((col) => ({
      label: col.email,
      value: col.user_id,
    }));
    setCurrentProjectId(record.id);
    setCurrentProjectOwner(record?.row?.owner ?? "");
    setCurrentCollaborator(collaborator);
    setOpenAssignUserModal(true);
  };

  function getLockUserInfo(
    collaborators,
    projectLockUserId,
    createdByObj,
    userInfo
  ) {
    const isLocked =
      projectLockUserId !== null && projectLockUserId !== undefined;
    let lockUserEmail = null;
    let lockUserId = null;
    if (isLocked) {
      lockUserId = projectLockUserId;
      const lockOwners = collaborators.filter(
        (collaborator) => collaborator.user_id === lockUserId
      );
      lockUserEmail = lockOwners?.[0]?.email ?? null;

      // If the locked user is the current user, use the current user's email
      if (lockUserId === userInfo?.id) {
        lockUserEmail = userInfo?.email ?? null;
      }

      if (lockUserEmail === null && createdByObj?.id == projectLockUserId) {
        lockUserEmail = createdByObj?.email ?? null;
      }
    }

    return { lockUserEmail, lockUserId };
  }

  const renderActions = (record) => (
    <div className="d-flex gap-[13px]">
      <span className="cursor-notallowed">
        <IconButton
          className="assignUser"
          onClick={(e) => handleAssignUser(e, record)}
        >
          {record?.row?.collaborators?.length > 0 ? (
            <Tooltip
              TransitionComponent={Fade}
              TransitionProps={{ timeout: 400 }}
              title="Remove User"
            >
              <span className="assign-remove-icon">
                <img
                  src={fileuserminus}
                  alt="fileuserminus"
                  className="assignIcon pointer-events-none"
                />
              </span>
            </Tooltip>
          ) : (
            <Tooltip
              TransitionComponent={Fade}
              TransitionProps={{ timeout: 400 }}
              title="Assign User"
            >
              <span className="assign-user-icon">
                <img src={fileuserplus} alt="fileuserplus" />
              </span>
            </Tooltip>
          )}
        </IconButton>
      </span>
      {/* action archive button */}
      <Button
        aria-controls={undefined}
        aria-haspopup="false"
        onClick={(event) => handleMenuClick(event, record)}
        className="actionDelete"
        endIcon={
          activeTab === PROJECT_TYPE.PROJECT ? (
            <img
              src={Binimage}
              alt="Archive"
              onClick={(event) => {
                handleMenuClick(event, record);
                setMultipleArchivedModal(true);
              }}
            />
          ) : (
            <div className="delete_icon_circular">
              <img
                src={delete_icon}
                alt="Delete"
                style={{ width: "20px", height: "15px" }}
                onClick={(event) => {
                  handleMenuClick(event, record);
                  setMultipleDeleteModal(true);
                }}
              />
            </div>
          )
        }
      ></Button>
    </div>
  );

  const columns = [
    {
      field: "name",
      headerName: "Project Name",
      flex: 1,
      minWidth: 180,
      headerClassName: "quant-app-theme--header",
      cellClassName: ["quant-app-theme--cell"],
      renderCell: (params) => (
        <Link
          to={`${routespath[0].createProjectDetails}/${params.row.id}`}
          className="project-name-link"
          onClick={(event) =>
            handleLinkClick(params.row.id, params?.row, event)
          }
        >
          {params.value}
        </Link>
      ),
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
      minWidth: 180,
      headerClassName: "quant-app-theme--header",
      cellClassName: "quant-app-theme--cell",
    },
    {
      field: "client_name",
      headerName: "Client Name",
      flex: 0.8,
      minWidth: 120,
      headerClassName: "quant-app-theme--header",
      cellClassName: "quant-app-theme--cell",
    },
    {
      field: "updated_at",
      headerName: "Last Updated",
      flex: 0.75,
      minWidth: 190,
      headerClassName: "quant-app-theme--header",
      cellClassName: "quant-app-theme--cell",
      renderCell: (params) => (
        <div className="dateIcon">
          <img src={Note} alt="date icon" />
          {format(new Date(params.row.updated_at), "dd-MMM-yyyy")}
        </div>
      ),
    },
    {
      field: "collborators",
      headerName: "Collaborators",
      renderCell: ({ row }) => renderCollaborators(row?.collaborators),
      flex: 0.5,
      minWidth: 160,
      headerClassName: "quant-app-theme--header",
      cellClassName: "quant-app-theme--cell",
    },
    {
      field: "projectLock",
      headerName: "Lock",
      renderCell: ({ row }) => renderSwitch(row?.collaborators, row?.id, row),
      flex: 0.5,
      minWidth: 60,
      headerClassName: "quant-app-theme--header",
      cellClassName: "quant-app-theme--cell",
    },
    {
      field: "action",
      headerName: "Actions",
      flex: 0.5,
      minWidth: 120,
      renderCell: (e) => renderActions(e),
      headerClassName: "quant-app-theme--header",
      cellClassName: "quant-app-theme--cell",
    },
  ];

  return (
    <div className="w-100 project-table-container">
      <StyledDataGrid
        sortingOrder={["desc", "asc"]}
        rowHeight={48}
        rows={data?.map((item, index) => ({
          ...item,
          id: item.id,
          key: index + item.id,
        }))}
        rowSelectionModel={selectedRow}
        onRowSelectionModelChange={(e) => setSelectedRow(e)}
        columns={columns}
        checkboxSelection
        disableRowSelectionOnClick={true}
        sx={{
          boxShadow: 3,
          border: 0,
          backgroundColor: "#fff",
          borderColor: "primary.light",
          "& .MuiDataGrid-cell:hover": {
            color: "primary.main",
          },
        }}
        components={{
          Pagination: () => (
            <Pagination
              count={Math.ceil(data.count / 2)}
              activepage={activepage}
              activeTab={activeTab}
              items={items}
              className="grid-pagination"
              handlePagination={handlePagination}
              pageValue={pageValue}
              setPageValue={setPageValue}
              data={data}
              selectedPage={selectedPage}
              setSelectedPage={setSelectedPage}
            />
          ),
        }}
      />
      {/* <Pagination /> */}
      <AssignUserModal
        projectId={currentProjectId}
        currentProjectOwner={currentProjectOwner}
        currentusername={currentusername}
        openModal={openAssignUserModal}
        setOpenModal={setOpenAssignUserModal}
        assigned={currentCollaborator}
        setAssigned={setCurrentCollaborator}
      />
      <AccessDeniedModal
        open={openAccessDeniedModal}
        userEmail={accessDeniedUserEmail}
        resetOpen={() => setOpenAccessDeniedModal(false)}
      />
    </div>
  );
};

export default ViewProjectTable;
